/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util';
import { deleteAction, getAction,downFile,getFileAccessHttpUrl } from '@/api/manage'
import Vue from 'vue'
import eventBus from '@/utils/eventBus'
import { ACCESS_TOKEN, TENANT_ID } from "@/store/mutation-types"
import store from '@/store'
import {Modal} from 'ant-design-vue'
import { checkHasPer } from "@/utils/authFilter"
import { getAccessToken } from '@/utils/token'
export const JeecgListMixin = {
  data(){
    return {
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource:[],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 15,
        pageSizeOptions: ['10','15', '20', '30','50','100','200','500'],
        showTotal: (total, range) => {
          //return range[0] + "-" + range[1] + " 共" + total + "条"
          return "共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
        exportColumn:[

        ],
      },
      /* 排序参数 */
      isorter:{
        column: 'updateTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* 请求失败标记：用于表格空态显示"数据加载失败"（全局 DmTableEmpty 依赖） */
      tableError:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:false,
      /* 高级查询条件生效状态 */
      superQueryFlag:false,
      searchQueryFlag:false,
      /* 高级查询条件 */
      superQueryParams: '',
      /** 高级查询拼接方式 */
      superQueryMatchType: 'and',
      superQueryFieldMap:{},
      timeOutEvent:0
    }
  },
  async created() {
      if(!this.disableMixinCreated){
        await this.loadColumn();
        this.loadData();
        //初始化字典配置 在自己页面定义
        this.initDictConfig();
      }
      // 全局工具栏「更改模板名/删除模板」转发到本页面的超级查询弹窗
      eventBus.$on('filter-rename-template', this.onRenameTemplateRequest)
      eventBus.$on('filter-delete-template', this.onDeleteTemplateRequest)
  },
  beforeDestroy() {
    eventBus.$off('filter-rename-template', this.onRenameTemplateRequest)
    eventBus.$off('filter-delete-template', this.onDeleteTemplateRequest)
  },
  computed: {
    //token header
    tokenHeader(){
      let head = {'X-Access-Token': getAccessToken()}
      let tenantid = Vue.ls.get(TENANT_ID)
      if(tenantid){
        head['tenant_id'] = tenantid
      }
      return head;
    }
  },
  methods:{
    checkHasPer,
    loadData(arg) {
      // if(this.loading){
      //   return;
      // }
      //this.selectedRowKeys = []
      if(!this.url.list){
        this.$message.error("请设置url.list属性!")
        return
      }
      // C1 竞态修复：组件级请求序号，快速切换/筛选时旧请求晚到直接丢弃，避免旧数据覆盖新数据
      const seq = (this._loadSeq = (this._loadSeq || 0) + 1)
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      var query = this.$route.params;
      if(query&&Object.keys(query).length){
        for(var yk in query){
          params[yk] = query[yk];
        }
      }
      this.loading = true;
      this.tableError = false;
      getAction(this.url.list, params).then((res) => {
        if (seq !== this._loadSeq) return; // 已有更新的请求，丢弃本次响应
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource = res.result.records||res.result;
          if(res.result.total)
          {
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
        }
        if(res.code===510){
          this.$message.warning(res.message)
        }
        this.loading = false;
      }).catch((err) => {
        if (seq !== this._loadSeq) return; // 旧请求失败同样丢弃，不误报
        // 接口失败兜底：结束加载态 + 标记失败（全局 DmTableEmpty 显示"数据加载失败"）
        this.loading = false;
        this.tableError = true;
        this.$message.error('数据加载失败，请稍后重试');
      })
    },
    initDictConfig(){
    },
    handleSuperQuery(params, matchType,queryParam) {

      //高级查询方法
      if(params && params.length){
        this.superQueryFlag = true
        this.superQueryParams=JSON.stringify(params)
        this.superQueryMatchType = matchType
      }else{
        this.superQueryParams=''
        this.superQueryFlag = false
      }
      if(queryParam){
        if(queryParam.reload){
          this.queryParam = {

          }
        }else{
          this.queryParam = {
            ...this.queryParam,
            ...queryParam
          }
        }

      }
      console.log("queryParam",queryParam)
      console.log("this.queryParam",this.queryParam)
      // 高级筛选执行：自动展开完整分页（有数据整理需求，直接显示总数/页码）
      this.showPagination = true;
      this.loadData(1)
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery() {
      this.loadData();
    },
    superQuery() {
      this.$refs.superQueryModal.show();
    },
    searchReset() {
      this.queryParam = {}
      this.loadData(1);
    },
    batchDel: function () {
      if(!this.url.deleteBatch){
        this.$message.error("请设置url.deleteBatch属性!")
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = "";
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
        var that = this;
        this.$confirm({
          title: "确认删除",
          content: "是否删除选中数据?",
          onOk: function () {
            that.loading = true;
            deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.loading = false;
            });
          }
        });
      }
    },
    handleDelete: function (id,isCall) {
      if(!this.url.delete){
        this.$message.error("请设置url.delete属性!")
        return
      }
      var that = this;
      deleteAction(that.url.delete, {id: id}).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          if(isCall){
            that.callbackOk();
          }else{
            that.loadData();
          }
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdd: function () {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.loadData();
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 给popup查询使用(查询区域不支持回填多个字段，限制只返回一个字段)
    getPopupField(fields){
      return fields.split(',')[0]
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
      //清空列表选中
      this.onClearSelected()
    },
    handleDetail:function(record){
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title="详情";
      this.$refs.modalForm.disableSubmit = true;
    },
    /* 导出 */
    handleExportXls2(){
      // C2 防连击：跳转导出中忽略重复点击
      if (this._exporting) {
        this.$message.warning('正在导出，请稍候')
        return
      }
      this._exporting = true
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()));
      let url = `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}?paramsStr=${paramsStr}`;
      window.location.href = url;
      // 跳转式导出：短暂锁 1.5s 防重复点击
      setTimeout(() => { this._exporting = false }, 1500)
    },
    handleExportXls(fileName){
      // C2 防连击：导出中忽略重复点击
      if (this._exporting) {
        this.$message.warning('正在导出，请稍候')
        return
      }
      this._exporting = true
      if(!fileName || typeof fileName != "string"){
        fileName = "导出文件"
      }
      let param = this.getQueryParams();
      if(this.selectedRowKeys && this.selectedRowKeys.length>0){
        param['selections'] = this.selectedRowKeys.join(",")
      }
      console.log("导出参数",param)
      downFile(this.url.exportXlsUrl,param).then((data)=>{
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      }).finally(() => {
        this._exporting = false
      })
    },
    /* 导入 */
    handleImportExcel(info){
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 201) {
            let { message, result: { msg, fileUrl, fileName } } = info.file.response
            let href = window._CONFIG['domianURL'] + fileUrl
            this.$warning({
              title: message,
              content: (<div>
                  <span>{msg}</span><br/>
                  <span>具体详情请 <a href={href} target="_blank" download={fileName}>点击下载</a> </span>
                </div>
              )
            })
          } else {
            this.$message.success(info.file.response.message || `${info.file.name} 文件上传成功`)
          }
          this.loadData()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`);
        }
      } else if (info.file.status === 'error') {
        if (info.file.response.status === 500) {
          let data = info.file.response
          const token = getAccessToken()
          if (token && data.message.includes("Token失效")) {
            Modal.error({
              title: '登录已过期',
              content: '很抱歉，登录已过期，请重新登录',
              okText: '重新登录',
              mask: false,
              onOk: () => {
                store.dispatch('Logout').then(() => {
                  Vue.ls.remove(ACCESS_TOKEN)
                  window.location.reload();
                })
              }
            })
          }
        } else {
          this.$message.error(`文件上传失败: ${info.file.msg} `);
        }
      }
    },
    /* 图片预览 */
    getImgView(text){
      if(text && text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      return getFileAccessHttpUrl(text)
    },
    /* 文件下载 */
    // update--autor:lvdandan-----date:20200630------for：修改下载文件方法名uploadFile改为downloadFile------
    downloadFile(text){
      if(!text){
        this.$message.warning("未知的文件")
        return;
      }
      if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      let url = getFileAccessHttpUrl(text)
      window.open(url);
    },customHeaderRow(conlumn){
      conlumn.forEach((e,index)=>{
        conlumn[index].className = 'header-class'
      })
    },customRow(record){
      return {
        class:"row-class",
        on:{
          // mousedown:(e)=>{
          //   if(e.target._prevClass=='ant-checkbox-input'
          //     || e.target._prevClass=='ant-table-selection-column'
          //     || e.target._prevClass=='tb-span-click'){
          //     return;
          //   }
          //   if(event.button==0){
          //     that.gotouchstart();
          //   }
          //
          // }
          // ,mouseup:(e)=>{
          //   if(e.target._prevClass=='ant-checkbox-input'
          //     || e.target._prevClass=='ant-table-selection-column'
          //     || e.target._prevClass=='tb-span-click'){
          //     return;
          //   }
          //   if(event.button==0){
          //     that.gotouchend(record);
          //   }
          //
          // }
          click:(e)=>{
              // 使用 closest 向上查找，更可靠地判断点击是否来自复选框或操作列
              const target = e.target
              if (target.closest('.ant-checkbox-wrapper')
                || target.closest('.ant-table-selection-column')
                || (target._prevClass && (target._prevClass == 'ant-checkbox-input'
                  || target._prevClass == 'ant-table-selection-column'
                  || target._prevClass == 'tb-span-click'))) {
                return;
              }
              if(e.button === 0){
                if(this.viewInfo){
                  this.viewInfo(record);
                }
              }
          }
        }
      }
    },getColumnMap(){
      let map = {};
      for(let a in this.defaultColumns){
        map[this.defaultColumns[a].dataIndex] = this.defaultColumns[a];
      }
      return map;
    },
    async loadColumn(){
      if(this.menuTab){
      await  getAction("/dm/dmTableSort/getMyTableSort",{menuTab:this.menuTab}).then(res=>{
          if(res.success){
            if(res.result){
             this.columns = [];
             let clentWidth = window.innerWidth-112;
             if(this.tableWidth){
               clentWidth = this.tableWidth;
             }
             let left = res.result.leftList;
             let center = res.result.centerList;
             let right = res.result.rightList;
             let rate = this.getWidthRate(left,center,right,clentWidth);
             //let length = (left?left.split(",").length:0)+(center?center.split(",").length:0)+(right?right.split(",").length:0)
             let map = this.getColumnMap();
             let tableWidth = this.getTableWidth(map,left+","+center+","+right);
                if(left){
                  let leftList = left.split(",");
                  for(let b in leftList){
                    if(map[leftList[b]]){
                      let column = Object.assign(map[leftList[b]],{});
                      column.fixed = 'left'
                      //if(tableWidth>clentWidth){
                        //column.fixed = 'left';
                      //}
                      column.position='left'
                      column.width = column.width * rate;
                      this.columns.push(column)
                    }
                  }
                }
                if(center){
                  let centerList = center.split(",");
                  for(let b in centerList){
                    if(map[centerList[b]]){
                      let column = Object.assign(map[centerList[b]],{});
                      column.position='center'
                      column.width = column.width * rate;
                      this.columns.push(column)
                    }
                  }
                }
                if(right){
                  let rightList = right.split(",");
                  for(let b in rightList){
                    if(map[rightList[b]]){
                      let column = Object.assign(map[rightList[b]],{});
                      if(tableWidth>clentWidth){
                        column.fixed = 'right';
                      }
                      column.position='right'
                      column.width = column.width * rate;
                      this.columns.push(column)
                    }
                  }
                }
                if(this.action){
                  this.columns.push(this.action)
                }
                this.itemKey = Math.random();
                // console.log("this.columns",this.columns)
                if(this.$refs.table) {
                  this.$refs.table.updateColumns();
                }

            }
            // 列配置为空(脏数据/未配置)时回退默认列,避免表格空白
            if(this.columns.length === 0 && this.defaultColumns){
              this.columns = Object.assign([], this.defaultColumns);
              this.itemKey = Math.random();
            }
            // 应用后端保存的列宽（跟随账号、换设备有记忆；widthJson 为空时各页面回退 localStorage）
            if(res.result && res.result.widthJson){
              try{
                let backendWidths = JSON.parse(res.result.widthJson);
                this.columns.forEach(col => {
                  if(backendWidths[col.dataIndex] !== undefined && backendWidths[col.dataIndex] !== null){
                    col.width = Number(backendWidths[col.dataIndex]);
                  }
                });
                if(this.$refs.table){
                  this.$refs.table.updateColumns();
                }
              }catch(e){ /* widthJson 损坏时忽略，沿用本地/默认宽度 */ }
            }
          }
        })
      }

    },getWidthRate(left,center, right,clentWidth){
      let map =this.getColumnMap()
       let width = 0;
       if( left){
         for(let a in left.split( ",")){
           let column = map[left.split( ",")[a]];
           if(column && column.width){
             width+=parseInt(column.width);
           }
         }
       }
       if( center){
         for(let a in center.split( ",")){
           let column = map[center.split( ",")[a]];
           if(column && column.width){
             width+=parseInt(column.width);
           }
         }
       }
       if( right){
         for(let a in right.split( ",")){
           let column = map[right.split( ",")[a]];
           if(column && column.width){
             width+=parseInt(column.width);
           }
         }
       }
       if(!width){
         return 1;
       }
       if(width>=clentWidth){
         return 1;
       }

       return clentWidth/width;
    },getTableWidth(map,str){
      let arr = str.split(",");
      let width = 0;
      for(let a in arr){
        if(map[arr[a]]){
          width+=map[arr[a]].width;
        }
      }
      return width;
    },changeSuperQuery(map){
      this.superQueryFieldMap = map;
    },
    // ===== 二级目录筛选条件独立记忆：按路由路径缓存/恢复（切换目录互不污染）=====
    // 注意：$route watch 触发时 this.$route 已是新路由，保存旧目录必须显式传 from.path
    saveFilterStateToCache(path) {
      const p = path || (this.$route ? this.$route.path : '') || (window.location.pathname || '')
      if (!p) return
      const key = 'dmFilterState_' + p
      try {
        localStorage.setItem(key, JSON.stringify({
          superQueryFieldMap: this.superQueryFieldMap || {},
          searchQueryFlag: !!this.searchQueryFlag,
          superQueryParams: this.superQueryParams || '',
          superQueryMatchType: this.superQueryMatchType || 'and',
          queryParam: this.queryParam ? Object.assign({}, this.queryParam) : {}
        }))
      } catch (e) {}
    },
    // 恢复指定路径的筛选条件；无缓存则清空（返回是否恢复成功）
    restoreFilterStateFromCache(path, forceClear) {
      if (!path) path = this.$route ? this.$route.path : ''
      const key = 'dmFilterState_' + path
      let raw = null
      try { raw = localStorage.getItem(key) } catch (e) {}
      let state = null
      if (raw && !forceClear) {
        try { state = JSON.parse(raw) } catch (e) { state = null }
      }
      if (state) {
        this.superQueryFieldMap = state.superQueryFieldMap || {}
        this.searchQueryFlag = !!state.searchQueryFlag
        this.superQueryParams = state.superQueryParams || ''
        this.superQueryMatchType = state.superQueryMatchType || 'and'
        if (state.queryParam) {
          this.queryParam = Object.assign({}, state.queryParam)
        }
        // 同步工具栏（模板按钮组）状态
        if (this.syncFilterSaveState) this.syncFilterSaveState()
        if (this.updateToolbarButtons) this.updateToolbarButtons()
        // 安全回填高级筛选弹窗内部条件（不触发查询/不清空，避免副作用丢失刚恢复的条件）
        this.$nextTick(() => {
          const modal = this.$refs.superQueryModal
          if (!modal) return
          try {
            const params = JSON.parse(this.superQueryParams)
            if (params && params.length) {
              modal.matchType = this.superQueryMatchType
              modal.queryParamsModel = JSON.parse(JSON.stringify(params))
              try { modal.notifyTemplateMatch() } catch (e) {}
            } else {
              // 缓存里没有高级条件：静默清弹窗即可，clear() 会触发一次多余的列表查询
              if (modal.silentClear) modal.silentClear()
              else modal.clear()
            }
          } catch (e) {}
        })
        return true
      }
      // 无缓存：清空条件，目录默认无筛选
      this.superQueryFieldMap = {}
      this.searchQueryFlag = false
      this.superQueryParams = ''
      this.superQueryMatchType = 'and'
      this.queryParam = {}
      this.$nextTick(() => {
        try {
          const modal = this.$refs.superQueryModal
          // 静默清空弹窗：clear() 会 emit handleSuperQuery 触发页面重查，
          // 目录切换时 init() 已按新目录查询，重复请求白白翻倍服务器压力
          if (modal) {
            if (modal.silentClear) modal.silentClear()
            else modal.clear()
          }
        } catch (e) {}
      })
      return false
    },searchSuper(column){
      this.$refs.superQueryModal.handleOpen(column.superName)
    },handleReset(){
      if(this.$refs.searchModal){
        this.$refs.searchModal.handleReset();
      }
      if(this.$refs.superQueryModal){
        this.$refs.superQueryModal.handleReset();
      }
    },searchBack(queryList){
      let hasSearch = false;
      for(let a in queryList){
        if(queryList[a].value && queryList[a].value.length){
          hasSearch = true;
        }
        this.queryParam[queryList[a].text] = queryList[a].value;
      }
      this.searchQueryFlag = hasSearch;
      this.searchQuery(1);
    },toExportXls(filedList,type){
      // C2 防连击：导出请求进行中忽略重复点击
      if (this._exporting) {
        this.$message.warning('正在导出，请稍候')
        return
      }
      this._exporting = true
      this.queryParam.filedList = filedList;

      let that = this;
      let param = this.getQueryParams();
      if(type==1){
        var ids = "";
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
        param.ids = ids;
      }
      getAction(this.url.exportColumUrl,param).then((res)=>{
        that._exporting = false
        if(res.success){
          that.$confirm({
            title: '提示',
            okText: '确认',
            cancelText: '取消',
            content: '表格正在导出中，前往导出列表查看？',
            onOk: () => {
              that.toExportList();
            },
            onCancel: () => {

            }
          })

        }else{
          that.$message.warning(res.message);
        }
      }).catch(() => {
        that._exporting = false
      });
    },toExportList(){
      this.$router.push({path:"/dm/export/exportList"});
    },clearSupper(){
      // if(this.$refs.superQueryModal){
      //   this.$refs.superQueryModal.clear();
      // }else{
      //   this.loadData(1);
      // }
      this.searchQuery();
    },openSupper(){
      this.$refs.superQueryModal.handleReset();
    },
    // 全局工具栏「更改模板名」：打开命名弹窗进入编辑模式（searchName 已匹配当前模板）
    onRenameTemplateRequest() {
      if (this.$refs.superQueryModal) {
        this.$refs.superQueryModal.showSaveBox()
      }
    },
    // 全局工具栏「删除模板」：删除当前匹配的模板
    onDeleteTemplateRequest(tpl) {
      if (this.$refs.superQueryModal && this.$refs.superQueryModal.deleteTemplate) {
        this.$refs.superQueryModal.deleteTemplate(tpl)
      }
    },
    // 切换 GlobalLayout 的高级筛选专用工具栏（$root 遍历直接设 filterState，
    // 不依赖 eventBus 监听注册时机，和调列宽模式设 resizeState 同一套路）
    setGlobalFilterState(on) {
      let layout = this.$root;
      while (layout) {
        if (layout.filterState !== undefined) {
          layout.filterState = on;
          break;
        }
        layout = layout.$children[0];
      }
    }
  }

}
